import { useSyncExternalStore } from 'react';

// ── Global odds display format: 'us' (American), 'dec' (decimal) or 'pct' (implied probability) ──
// Persisted to localStorage and shared by every screen. Sidebar owns the toggle.
export const ODDS_FORMAT_KEY = 'sharpstackOddsFormat';
export const MODES = ['us', 'dec', 'pct'];

const read = () => {
  try { const v = localStorage.getItem(ODDS_FORMAT_KEY); return MODES.includes(v) ? v : 'us'; } catch (e) { return 'us'; }
};

let current = read();
const listeners = new Set();
const notify = () => listeners.forEach(l => { try { l(); } catch (e) { /* ignore */ } });

export const getOddsFormat = () => current;

export const setOddsFormat = (mode) => {
  const next = MODES.includes(mode) ? mode : 'us';
  if (next === current) return;
  current = next;
  try { localStorage.setItem(ODDS_FORMAT_KEY, next); } catch (e) { /* storage may be blocked in iframe */ }
  notify();
};

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

// Cross-tab sync
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === ODDS_FORMAT_KEY) { const next = read(); if (next !== current) { current = next; notify(); } }
  });
}

export const useOddsFormat = () => useSyncExternalStore(subscribe, getOddsFormat, getOddsFormat);

/** Format an American price for display in the current (or given) mode. */
export const fmtPrice = (price, mode = current) => {
  if (price == null || price === '' || price === '-') return '';
  const p = Number(price);
  if (!Number.isFinite(p)) return '';
  if (mode === 'pct') {
    const prob = p > 0 ? 100 / (p + 100) : -p / (-p + 100);
    return `${(prob * 100).toFixed(1)}%`;
  }
  if (mode === 'dec') {
    const dec = p > 0 ? 1 + p / 100 : 1 + 100 / -p;
    return dec.toFixed(2);
  }
  return p > 0 ? `+${p}` : `${p}`;
};

/** Hover text showing a price in every format, e.g. "+150  |  2.50  |  40.0%". undefined if no price. */
export const fmtAllFormats = (price) => {
  const us = fmtPrice(price, 'us');
  if (!us) return undefined;
  return `${us}  |  ${fmtPrice(price, 'dec')}  |  ${fmtPrice(price, 'pct')}`;
};